import styled, { css } from 'styled-components';

export const BreadcrumbsSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  color: ${({ theme }) => theme.color.tint.tertiary};

  a {
    ${({ theme }) => css`
      color: ${theme.color.tint.secondary};
      transition-property: color, opacity;
      transition-duration: 0.2s;
      text-decoration: none;
      ${theme.mappedTypography.overline.default};

      &:hover {
        color: ${theme.color.tint.highlight} !important;
      }

      &:visited {
        color: ${theme.color.tint.tertiary};
      }

      &:active,
      &.active {
        color: ${theme.color.state.active} !important;
      }

      &:disabled {
        opacity: 0.5;
        color: ${theme.color.tint.highlight};
      }
    `};
  }
`;
